<template>
  <div>
    <v-container>
      <v-row>
        <v-col :class="classPadding">
          <v-btn @click.prevent="exportReport" outlined text :class="classPadding" :loading="loading">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/reports"
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    loading: false
  }),
  methods: {
    async exportReport() {  
      try{
        this.loading = true
        var response = await this.$axios.post(`${API_ENDPOINT}/pme-level-setup`)

        var nameOfTheCsv = "PmeLevelReport.xlsx";
        var response2 = await this.$axios.get(`${API_ENDPOINT}/pme-level-setup/${response.data}`, {responseType: 'blob'})
            // .then(response => {
            //     const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            //     const link = document.createElement('a');
            //     link.href = downloadUrl;
            //     link.setAttribute('download', nameOfTheCsv);
            //     document.body.appendChild(link);
            //     link.click();
            //     link.remove();
            // }).catch(err => console.log(err));
        const downloadUrl = window.URL.createObjectURL(new Blob([response2.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', nameOfTheCsv);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }catch(error){
        this.$toast.error(error.message);
        throw new Error(error.message)
      }finally {
        this.loading = false
      }
      
    }
  }
}
</script>